// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ModbusReadEntry, ModbusReadEntryT, verifyModbusReadEntry } from "./modbus-read-entry";
import {
  ModbusRegisterOffsetMap,
  ModbusRegisterOffsetMapT,
  verifyModbusRegisterOffsetMap,
} from "./modbus-register-offset-map";
import { ModbusWriteEntry, ModbusWriteEntryT, verifyModbusWriteEntry } from "./modbus-write-entry";

/**
 * Complete Modbus CDO template stored in `cdo_binary` for Modbus adapters.
 * Expands to a `Modbus.Mapping` at CDO generation time.
 */
export class ModbusTemplate implements flatbuffers.IUnpackableObject<ModbusTemplateT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModbusTemplate {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModbusTemplate(bb: flatbuffers.ByteBuffer, obj?: ModbusTemplate): ModbusTemplate {
    return (obj || new ModbusTemplate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsModbusTemplate(
    bb: flatbuffers.ByteBuffer,
    obj?: ModbusTemplate,
  ): ModbusTemplate {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModbusTemplate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  reads(index: number, obj?: ModbusReadEntry): ModbusReadEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new ModbusReadEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  readsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  writes(index: number, obj?: ModbusWriteEntry): ModbusWriteEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new ModbusWriteEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  writesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  slaveId(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  pollingInterval(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  /**
   * Per-register-type Initial/Delta offsets used by the bank matrix
   * to expand a single adapter mapping over N lifts. The field is
   * optional — null means "no per-lift expansion, use base addresses
   * verbatim". Appended last for binary backward compatibility with
   * existing templates persisted in `cdo_binary`.
   */
  registerOffsets(obj?: ModbusRegisterOffsetMap): ModbusRegisterOffsetMap | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new ModbusRegisterOffsetMap()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  static startModbusTemplate(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addReads(builder: flatbuffers.Builder, readsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, readsOffset, 0);
  }

  static createReadsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startReadsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addWrites(builder: flatbuffers.Builder, writesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, writesOffset, 0);
  }

  static createWritesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startWritesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addSlaveId(builder: flatbuffers.Builder, slaveId: number) {
    builder.addFieldInt8(2, slaveId, null);
  }

  static addPollingInterval(builder: flatbuffers.Builder, pollingInterval: bigint) {
    builder.addFieldInt64(3, pollingInterval, 0n);
  }

  static addRegisterOffsets(
    builder: flatbuffers.Builder,
    registerOffsetsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(4, registerOffsetsOffset, 0);
  }

  static endModbusTemplate(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static finishModbusTemplateBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset);
  }

  static finishSizePrefixedModbusTemplateBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, undefined, true);
  }

  unpack(): ModbusTemplateT {
    return new ModbusTemplateT(
      this.bb!.createObjList<ModbusReadEntry, ModbusReadEntryT>(
        this.reads.bind(this),
        this.readsLength(),
      ),
      this.bb!.createObjList<ModbusWriteEntry, ModbusWriteEntryT>(
        this.writes.bind(this),
        this.writesLength(),
      ),
      this.slaveId(),
      this.pollingInterval(),
      this.registerOffsets() !== null ? this.registerOffsets()!.unpack() : null,
    );
  }

  unpackTo(_o: ModbusTemplateT): void {
    _o.reads = this.bb!.createObjList<ModbusReadEntry, ModbusReadEntryT>(
      this.reads.bind(this),
      this.readsLength(),
    );
    _o.writes = this.bb!.createObjList<ModbusWriteEntry, ModbusWriteEntryT>(
      this.writes.bind(this),
      this.writesLength(),
    );
    _o.slaveId = this.slaveId();
    _o.pollingInterval = this.pollingInterval();
    _o.registerOffsets = this.registerOffsets() !== null ? this.registerOffsets()!.unpack() : null;
  }

  unpackFields(...fields: string[]): ModbusTemplateT {
    const t = new ModbusTemplateT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("reads")) {
      t.reads = this.bb!.createObjList<ModbusReadEntry, ModbusReadEntryT>(
        this.reads.bind(this),
        this.readsLength(),
      );
    }
    if (fieldSet.has("writes")) {
      t.writes = this.bb!.createObjList<ModbusWriteEntry, ModbusWriteEntryT>(
        this.writes.bind(this),
        this.writesLength(),
      );
    }
    if (fieldSet.has("slave_id")) {
      t.slaveId = this.slaveId();
    }
    if (fieldSet.has("polling_interval")) {
      t.pollingInterval = this.pollingInterval();
    }
    if (fieldSet.has("register_offsets")) {
      t.registerOffsets = this.registerOffsets() !== null ? this.registerOffsets()!.unpack() : null;
    }
    return t;
  }
}

export class ModbusTemplateT implements flatbuffers.IGeneratedObject {
  constructor(
    public reads: ModbusReadEntryT[] = [],
    public writes: ModbusWriteEntryT[] = [],
    public slaveId: number | null = null,
    public pollingInterval: bigint = 0n,
    public registerOffsets: ModbusRegisterOffsetMapT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const reads = ModbusTemplate.createReadsVector(
      builder,
      builder.createObjectOffsetList(this.reads),
    );
    const writes = ModbusTemplate.createWritesVector(
      builder,
      builder.createObjectOffsetList(this.writes),
    );
    const registerOffsets = this.registerOffsets !== null ? this.registerOffsets!.pack(builder) : 0;

    ModbusTemplate.startModbusTemplate(builder);
    ModbusTemplate.addReads(builder, reads);
    ModbusTemplate.addWrites(builder, writes);
    if (this.slaveId !== null) ModbusTemplate.addSlaveId(builder, this.slaveId);
    ModbusTemplate.addPollingInterval(builder, this.pollingInterval);
    ModbusTemplate.addRegisterOffsets(builder, registerOffsets);

    return ModbusTemplate.endModbusTemplate(builder);
  }

  clone(): ModbusTemplateT {
    const obj = new ModbusTemplateT();
    obj.reads = this.reads.map((e) => e.clone());
    obj.writes = this.writes.map((e) => e.clone());
    obj.slaveId = this.slaveId;
    obj.pollingInterval = this.pollingInterval;
    obj.registerOffsets = this.registerOffsets !== null ? this.registerOffsets!.clone() : null;
    return obj;
  }

  equals(other: ModbusTemplateT): boolean {
    if (this.reads.length !== other.reads.length) return false;
    for (let i = 0; i < this.reads.length; i++) {
      const a = this.reads[i];
      const b = other.reads[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.writes.length !== other.writes.length) return false;
    for (let i = 0; i < this.writes.length; i++) {
      const a = this.writes[i];
      const b = other.writes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.slaveId !== other.slaveId) return false;
    if (this.pollingInterval !== other.pollingInterval) return false;
    if (this.registerOffsets !== null && other.registerOffsets !== null) {
      if (!this.registerOffsets!.equals(other.registerOffsets!)) return false;
    } else if (this.registerOffsets !== other.registerOffsets) return false;
    return true;
  }
}

export function verifyModbusTemplate(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyModbusReadEntry);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyModbusWriteEntry);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 8);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 12);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyModbusRegisterOffsetMap(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsModbusTemplate(
  buf: DataView,
  opts?: flatbuffers.VerifierOptions,
): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyModbusTemplate(verifier, tablePos);
}
